function stripFileExtension(fileName: string): string {
  return String(fileName || "").replace(/\.[^.]+$/, "");
}

function pad2(value: string | number): string {
  return String(value).padStart(2, "0");
}

function toIsoDate(year: string, month: string, day: string): string {
  const yearNumber = Number(year);
  const monthNumber = Number(month);
  const dayNumber = Number(day);
  if (!Number.isInteger(yearNumber) || !Number.isInteger(monthNumber) || !Number.isInteger(dayNumber)) return "";
  if (yearNumber < 1900 || yearNumber > 2099) return "";

  const date = new Date(Date.UTC(yearNumber, monthNumber - 1, dayNumber));
  if (
    date.getUTCFullYear() !== yearNumber ||
    date.getUTCMonth() !== monthNumber - 1 ||
    date.getUTCDate() !== dayNumber
  ) {
    return "";
  }

  return `${yearNumber}-${pad2(monthNumber)}-${pad2(dayNumber)}`;
}

export function extractProjectNumberFromProjectFileName(fileName: string): string {
  const baseName = stripFileExtension(fileName);
  const patterns = [
    /^\s*(\d{4,6})(?=\s*[-_ ]|\b)/,
    /\b(project|job|quote|quotation)\s*[-_# ]\s*(\d{4,6})\b/i,
    /\b(\d{4,6})\b/,
  ];

  for (const pattern of patterns) {
    const match = baseName.match(pattern);
    const candidate = match?.[2] || match?.[1];
    if (candidate) return candidate;
  }
  return "";
}

export function extractRevisionDateFromProjectFileName(fileName: string): string {
  const baseName = stripFileExtension(fileName);
  const candidates: Array<{ index: number; value: string }> = [];

  const compactPattern = /(^|[^\d])((?:19|20)\d{2})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])(?=$|[^\d])/g;
  for (const match of baseName.matchAll(compactPattern)) {
    const value = toIsoDate(match[2], match[3], match[4]);
    if (value) candidates.push({ index: (match.index || 0) + match[1].length, value });
  }

  const yearFirstPattern = /(^|[^\d])((?:19|20)\d{2})[-_. ](0?[1-9]|1[0-2])[-_. ](0?[1-9]|[12]\d|3[01])(?=$|[^\d])/g;
  for (const match of baseName.matchAll(yearFirstPattern)) {
    const value = toIsoDate(match[2], match[3], match[4]);
    if (value) candidates.push({ index: (match.index || 0) + match[1].length, value });
  }

  const dayFirstPattern = /(^|[^\d])(0?[1-9]|[12]\d|3[01])[-_. ](0?[1-9]|1[0-2])[-_. ]((?:19|20)\d{2})(?=$|[^\d])/g;
  for (const match of baseName.matchAll(dayFirstPattern)) {
    const value = toIsoDate(match[4], match[3], match[2]);
    if (value) candidates.push({ index: (match.index || 0) + match[1].length, value });
  }

  return candidates.sort((left, right) => left.index - right.index)[0]?.value || "";
}
